import { last } from 'ramda';
import { CLAIM_STATUS_LABELS, getClaimProgress } from '../helpers';

const useClaimProgression = (claim) => {
  const { statusUpdates, claimSubmissionStatus } = claim;

  const latestStatusUpdate = last(statusUpdates);
  const progress = getClaimProgress(claim, latestStatusUpdate);
  const isDeclined = progress.label === CLAIM_STATUS_LABELS.DECLINED;
  const isComplete = progress.label === CLAIM_STATUS_LABELS.DONE;
  const isDraft = claimSubmissionStatus === 'Filing';

  return { progress, latestStatusUpdate, isDeclined, isDraft, isComplete };
};

export default useClaimProgression;
